import React from 'react';
import { CircularProgress } from '@mui/material';

import classes from './LoadingOverlay.module.scss';

export const LoadingOverlay: React.FC = () => {
    return (
        <div className={classes.root}>
            <CircularProgress className={classes.spinner} />
        </div>
    );
};
